// extracted by mini-css-extract-plugin
export default {"OverviewFormFieldsContainer":"OverviewFormFields_OverviewFormFieldsContainer__YD8RM","InformationContainer":"OverviewFormFields_InformationContainer__IFunZ"};